/**
 * The words for a field-force job's status (T096), the same on every screen -
 * web and phone, painter and vendor - so one status never reads as two
 * different things. A status with no words yet falls back to its code.
 */
export function painterStatusLabel(t: (key: string) => string, status: string): string {
  const key = `painterStatus.${status}`;
  const label = t(key);
  return label === key ? status : label;
}
